// extracted by mini-css-extract-plugin
export default {"container":"Headers_container_Dpebz","content":"Headers_content_PDbRL","column":"Headers_column_n6KHk","edit":"Headers_edit_gTyDH"};